// hooks/useCustomerMetrics.js
import { useQuery } from '@tanstack/react-query';
import { reactQueryFinanceDefaults } from './queryDefaults';
import apiService from '../../services/api';
import { ENDPOINTS } from '../../services/endpoints';

const useCustomerMetrics = (dateRange) => {
  const fetchCustomerMetrics = async () => {
    const [ltvResponse, churnResponse] = await Promise.all([
      apiService.get(ENDPOINTS.FINANCE_CUSTOMER_LTV, {
        start_date: dateRange?.start_date,
        end_date: dateRange?.end_date,
      }),
      apiService.get(ENDPOINTS.FINANCE_CUSTOMER_CHURN, {
        start_date: dateRange?.start_date,
        end_date: dateRange?.end_date,
      })
    ]);

    const currentLTV = 
      ltvResponse?.data?.data?.average_ltv || 
      ltvResponse?.data?.average_ltv || 
      ltvResponse?.average_ltv || 
      0;
    
    const currentChurn = 
      churnResponse?.data?.data?.current_churn_rate || 
      churnResponse?.data?.current_churn_rate || 
      churnResponse?.current_churn_rate || 
      0;

    return {
      ltvData: { ltv: currentLTV, change: 0 },
      churnData: { churnRate: currentChurn, change: 0 },
      lastUpdated: new Date().toISOString(),
    };
  };

  const {
    data,
    isLoading,
    isFetching,
    isError,
    error,
    refetch,
    } = useQuery({
      queryKey: ['customerMetrics', dateRange?.start_date, dateRange?.end_date],
      queryFn: fetchCustomerMetrics,
      ...reactQueryFinanceDefaults,
      enabled: !!dateRange?.start_date && !!dateRange?.end_date,
    });

  return {
    // Customer metrics data
    ltvData: data?.ltvData || { ltv: 0, change: 0 },
    churnData: data?.churnData || { churnRate: 0, change: 0 },
    lastUpdated: data?.lastUpdated || null,
    
    // Loading states
    loading: isLoading,
    refreshing: isFetching,
    
    // Error handling
    error: isError ? (error?.message || 'Failed to load customer metrics') : null,
    isError,
    
    // Status
    initialized: !!data,
    
    // Actions
    refetch,
  };
};

export { useCustomerMetrics };
